import axios from 'axios';

const API_BASE = '/api/dashboard';

export const dashboardService = {
  getActivityFeed: async (params = {}, axiosConfig = {}) => {
    const response = await axios.get(`${API_BASE}/activity-feed`, { params, ...axiosConfig });
    return response.data;
  }
};
